import React, { memo } from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'

/**
 * ATTRIBUTED CONTENT — see CONTENT-ARCHITECTURE §0.
 *
 * The blockquote and the two body paragraphs below sit above a named person
 * with his photo and title, so a reader takes the whole left column as him
 * speaking. Rewriting any of it would alter words attributed to a real person,
 * which §0 forbids. Those three blocks are therefore FROZEN.
 *
 * Only the eyebrow and these stat labels are rewritten — they are the section's
 * own furniture, not part of the attributed statement.
 */
const STATS = [
  { num: '8+',  unit: 'years',      label: 'Building production software for businesses your size.' },
  { num: '3+',  unit: 'multi-year', label: 'US client relationships still active today.'            },
  { num: '100', unit: '%',          label: 'Founder involvement on every engagement.'               },
  { num: '3',   unit: 'regions',    label: 'US, Europe and Middle East.'                            },
]

const OriginStory = () => {
  const data = useStaticQuery(graphql`
    query {
      tauseef: file(relativePath: { eq: "about/tauseef.png" }) {
        childImageSharp {
          fixed(width: 106, height: 106, quality: 95, cropFocus: ATTENTION) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
    }
  `)

  return (
  <section className="os-section">
    <span className="os-eyebrow">Who you would be working with</span>
    <div className="os-inner">
      {/* ── Left: story ── */}
      <div className="os-left">
        <blockquote className="os-quote">
          No client has ever had to start over. The team that begins your project is the team that finishes it — because we engineered our company around finishing what we start.
        </blockquote>
        <p className="os-body">
          Visiomate was built on a frustration most business owners know: too many software development vendors that overpromise, underdeliver, and quietly die after months of invoices.
        </p>
        <p className="os-body">
          We don't deliver solutions. We deliver the outcomes our clients hired us to achieve — and we stay until those outcomes are real.
Today, we work with growing businesses across the US, Europe, and Middle East. Some of those relationships are now in their third year and still going.
        </p>
        <div className="os-author">
          <Img fixed={data.tauseef.childImageSharp.fixed} alt="Muhammad Tauseef" className="os-author__avatar" />
          <div className="os-author__name">
            <strong>Muhammad Tauseef Yunis Bhutti</strong>
            CEO &amp; Co-Founder, Visiomate
          </div>
        </div>
      </div>

      {/* ── Divider ── */}
      {/* <div className="os-divider" /> */}

      {/* ── Right: stat cards ── */}
      <div className="os-right">
        {STATS.map(({ num, unit, label }, i) => (
          <div key={i} className="os-stat-card">
            <span className="os-stat-card__value">
              {num}<span className="os-stat-card__unit">{unit}</span>
            </span>
            <span className="os-stat-card__label">{label}</span>
          </div>
        ))}
      </div>

    </div>
  </section>
  )
}

export default memo(OriginStory)
